<template>
  <v-dialog v-model="dialog" width="520">
    <category-form
      v-model="newCategory"
      :icon-list="iconList"
      :is-loading="isLoading"
      @submit="onCreate"
    />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import CategoryForm from './CategoryForm.vue';

export default {
  name: 'new-category-dialog',
  components: { CategoryForm },
  mixins: [DialogBusMixin],
  props: {
    iconList: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    newCategory: null,
    isLoading: false,
  }),
  methods: {
    ...mapActions('categories', ['create']),
    ...mapActions(['showNotify']),

    beforeOpen() {
      this.newCategory = null;
    },

    async onCreate() {
      this.isLoading = true;

      try {
        await this.create(this.newCategory);
        this.$emit('submitted');
        this.showNotify({ message: 'Категория успешно создана' });
        this.dialog = false;
      } catch (e) {
        this.showNotify({ type: 'error', message: 'Что-то пошло не так' });
        throw e;
      }

      this.isLoading = false;
    },
  },
};
</script>
